/** Türkçe sözlük · hareketler. Şekli bu dosya tanımlar; öteki diller ona bağlıdır. */
export const hareketler = {
  /** Hareketler ekranı (`screens/TransactionsScreen.tsx`). */
  ekran: {
    baslik: "Hareketler",
    aciklama: "Yatırım hareketlerinin ham kaydı. Silinen kayıtlar listede görünmez.",
    yenileniyor: "Yenileniyor",
    hareketEkle: "Hareket ekle",
    filtreler: "Hareket filtreleri",
    hesap: "Hesap",
    tur: "Tür",
    ara: "Varlık / not ara",
    araIpucu: "Yalnızca görünen sayfada arar.",
    araOrnek: "THYAO, altın…",
    filtreleriTemizle: "Filtreleri temizle",
    yukleniyor: "Hareketler yükleniyor…",
    filtreyeUyanYok: "Bu filtreye uyan hareket yok",
    henuzYok: "Henüz hareket yok",
    filtreleriGevset: "Filtreleri gevşetin ya da temizleyin.",
    henuzYokMetin: "Alış, satış, temettü, para giriş/çıkışı — hepsi burada tutulur.",
    ilkHareket: "İlk hareketi ekle",
    liste: "Hareket listesi",
    tarih: "Tarih",
    varlik: "Varlık",
    miktar: "Miktar",
    fiyatTutar: "Fiyat / tutar",
    masraf: "Masraf",
    vergi: "Vergi",
    islem: "İşlem",
    izlenen: "izlenen",
    elle: "elle",
    saltOkunur: "Bu hesap salt okunur (Abonelik).",
    sayfalama: "Sayfalama",
    toplamOnEk: "Toplam ",
    /** Sayı yalnızca çoğul eki olan dillerde kullanılır. */
    kayitSayfa: (_toplam: number) => " kayıt · sayfa",
    aramaSatir: (n: string) => ` · sayfada aramayla ${n} satır`,
    sayfaBoyu: "Sayfa boyu",
    onceki: "Önceki",
    sonraki: "Sonraki",
    hareketiDuzenle: "Hareketi düzenle",
    formAciklama: "Alanlar hareket türüne göre değişir.",
    silOnayBaslik: "Hareket silinsin mi?",
    silOnayMetin: "Kayıt fiziksel olarak silinmez, silindi olarak işaretlenir (tombstone) ve listeden kalkar.",
  },
  /** Hareket formu (`components/TransactionForm.tsx`). */
  form: {
    hesapSecin: "Hesap seçin.",
    tarihZorunlu: "İşlem tarihi zorunlu.",
    valorOnce: "Valör, işlem tarihinden önce olamaz.",
    paraBirimiSecin: "Listeden bir para birimi seçin.",
    kimlikZorunlu: "Araç kimliği zorunlu.",
    etiketZorunlu: "Varlık etiketi zorunlu.",
    vergiYili: "Verginin ait olduğu yılı yazın (ör. 2025).",
    alinanFarkli: "Alınan para birimi verilenden farklı olmalı.",
    /** "Parayı çektim" ile oluşan çekme hareketinin notu. */
    cekmeNotu: "Satış parası çekildi",
    hesap: "Hesap",
    onceHesap: "Önce hesap ekleyin",
    hareketTuru: "Hareket türü",
    paraBirimi: "Para birimi",
    islemTarihi: "İşlem tarihi",
    valor: "Valör",
    valorNakit: "Paranın hesaba geçtiği gün; kur bu günden alınır. Boşsa işlem günü.",
    valorTakas: "Takas tarihi. Boş bırakılabilir.",
    birimFiyat: "Birim fiyat",
    alinanParaBirimi: "Alınan para birimi",
    alinanTutar: "Alınan tutar",
    masraf: "Masraf",
    vergiStopaj: "Vergi / stopaj",
    kurElle: "Kur (elle)",
    kurElleIpucu: "TCMB kurunu geçersiz kılmak için. Boş bırakın.",
    nakitNotu: "Nakit hareketi: varsayılan olarak elle etiketli nakit varlığına bağlanır.",
    temettuden: "Temettüyle alındı (geri yatırım)",
    temettudenMetin:
      "Maliyete girer; “geçmiş dahil getiri %”nin paydasına (cepten çıkan para) girmez. Alışın yalnızca bir kısmı temettüyse işaretlemeyin ya da alışı ikiye bölün.",
    aitYil: "Ait olduğu yıl",
    kaynak: "Kaynak",
    kaynakNakit: "Hesaptaki nakitten",
    kaynakDisaridan: "Dışarıdan (hesaba girmeden ödendi; para girişi sayılır)",
    paraCektim: "Parayı çektim",
    paraCektimMetin: "Satıştan gelen net tutar için aynı gün bir para çekme hareketi oluşur.",
    not: "Not",
    nasilBaslik: "Bu tür nasıl kaydedilir",
    nasilOnce: "Sözleşmedeki ",
    nasilTip: ' tipinde ayrı bir "tutar" alanı yok. Nakit hareketleri',
    nasilMiktar: " miktar = 1",
    nasilVirgul: ", ",
    nasilBirimFiyat: "birim fiyat = tutar",
    nasilSonra: ' olarak yazılır; böylece "brüt = miktar × fiyat" kuralı her türde geçerli kalır.',
    varlikSiniri: "Bu hesaba yeni bir varlık eklemek",
  },
  /** Hareket türüne göre alanlar (`lib/txShape.ts`). */
  sekil: {
    miktar: "Miktar",
    alimSatimIpucu: "Brüt tutar = miktar × birim fiyat. Masraf ve vergi ayrı alanlarda.",
    tutar: "Tutar",
    nakitIpucu: "Nakit hareketi: miktar/fiyat yok, yalnızca tutar girilir.",
    miktarFarki: "Miktar farkı",
    miktarFarkiIpucu: "Oran değil, miktar farkı girilir (artış pozitif, azalış eksi).",
    alinanMiktar: "Alınan miktar",
    ruchanIpucu: "Rüçhan hakkı kullanımı: alınan miktar ve ödenen birim bedel.",
    gelenMiktar: "Gelen miktar",
    devirGirisIpucu: "Başka kurumdan devir. Birim maliyet biliniyorsa girin, zorunlu değil.",
    cikanMiktar: "Çıkan miktar",
    devirCikisIpucu: "Başka kuruma devir. Birim maliyet biliniyorsa girin, zorunlu değil.",
    bolunmeIpucu: "Bölünme sonrası oluşan miktar farkı.",
    bedelsizMiktar: "Bedelsiz gelen miktar",
    bedelsizIpucu: "Bedelsiz pay girişi.",
    netTutar: "Net tutar",
    temettuIpucu: "Temettü nakit girişidir: hangi varlıktan geldiğini seçin, tutarı girin.",
    faizTutari: "Faiz tutarı",
    faizIpucu: "Faiz/kupon geliri.",
    yatanTutar: "Yatan tutar",
    yatirmaIpucu: "Hesaba para girişi.",
    cekilenTutar: "Çekilen tutar",
    cekmeIpucu: "Hesaptan para çıkışı.",
    masrafTutari: "Masraf tutarı",
    masrafIpucu: "Komisyon, saklama ücreti, damga.",
    odenenTutar: "Ödenen tutar",
    vergiIpucu: "Beyanla ödenen vergi. Ödenecek vergi tahmin edilmez; yalnızca yaptığınız ödeme.",
    verilenTutar: "Verilen tutar",
    dovizIpucu:
      "Aynı hesapta bir para biriminden ötekine geçiş: para girişi ya da çıkışı sayılmaz. Verilen ve alınan tutarı ekstredeki gibi girin; kur ikisinin oranıdır.",
  },
  /** Hesap silinirken hareketler (`components/HareketSecimi.tsx`). */
  secim: {
    soru: (n: number) => `Bu hesaba bağlı ${n} hareket ne olsun?`,
    sil: "Hareketler de silinsin",
    tasi: "Başka bir hesaba taşınsın — baştan beri o hesaptaymış gibi sayılır",
    hedefYok: "Taşınabilecek başka hesap yok.",
    hedef: "Taşınacak hesap",
    hesapSecin: "Hesap seçin",
  },
  /** Nakit takibi seçenekleri (`lib/nakitTakibi.ts`). */
  nakitTakibi: {
    kendiliginden: "Otomatik (yatırma/çekme varsa açık)",
    acik: "Açık",
    kapali: "Kapalı",
  },
  /** Kilit ekranı deneme sınırı (`lib/denemeSiniri.ts`). */
  deneme: {
    saniye: (n: number) => `${n} saniye`,
    dakika: (n: number) => `${n} dakika`,
    bekleme: (sure: string) => `Art arda çok sayıda yanlış deneme: ${sure} sonra yeniden deneyin.`,
  },
};
